import(/* webpackMode: "eager" */ "/vercel/path0/src/app/forgot-password/page.jsx");
